// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202607201604/js/" + chunkId + "." + {"44":"6f6a8ed5","225":"8d8b3a45","481":"6c0be570","486":"9e6b2aed","770":"4671b2e0"}[chunkId] + ".0.13353643638078083.chunk.js";
};